import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { tableCellClasses } from "@mui/material/TableCell";
import s from "./subscription.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Pagination,
  Box,
} from "@mui/material";
import { notificationHandler } from "../../utils/Notification";
import Loder from "../../Loder/Loder";
import { BiFilter, BiSearch } from "react-icons/bi";
import DataNotFound from "../ErrorPage/DataNotFound";
import { IoMdAdd } from "react-icons/io";
import {
  deleteSubscription_api,
  get_all_Subscription,
  subscription_status_api,
} from "../api/subscription";
import { getBaseUrl2 } from "../../utils";
import xlsx from "json-as-xlsx";
import { toast } from "react-toastify";

const SubscriptonList = () => {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [allSubscription, setallSubscription] = useState([]);
  const [pageCount, setpageCount] = useState(1);
  const [deleteId, setdeleteId] = useState("");
  const [deletePopup, setdeletePopup] = useState(false);
  const [currentGroup, setcurrentGroup] = useState({});
  const [search, setsearch] = useState("");
  const [pageLength, setpageLength] = useState();
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [statusFilter, setstatusFilter] = useState();
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");

  useEffect(() => {
    fetchAllSubscriptionList();
  }, [pageCount, search, startDate, endDate, statusFilter]);

  // console.log(allSubscription, "all media datas");

  const fetchAllSubscriptionList = async () => {
    setisLoading(true);
    let temp = {
      page: pageCount,
      limit: 15,
      search: search?.trim(),
      status: statusFilter,
      startDate: startDate,
      endDate: endDate,
    };
    try {
      let res = await get_all_Subscription(temp);
      if (res.data.status) {
        setallSubscription(res?.data?.data?.subscription);
        setisLoading(false);
      } else {
        setisLoading(false);
        console.log("false Status!");
      }
    } catch (error) {
      setisLoading(false);
      console.log(error);
    }
  };
  async function deleteSubscriptionFunc() {
    setisLoading(true);
    let temp = {
      id: deleteId,
    };
    try {
      let res = await deleteSubscription_api(temp);
      if (res.data.success) {
        setisLoading(false);
        setdeletePopup(false);
        fetchAllSubscriptionList();
        notificationHandler({ type: "success", msg: res?.data?.message });
      } else {
        setisLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      notificationHandler({ type: "danger", msg: error.message });
    }
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--clr-theme)",
      color: theme.palette.common.white,
      fontWeight: "bold",
      borderRight: "1px solid #fff",
      overflow: "hidden",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "none",
      borderLeft: "2px solid #00000011",
      "&:last-child": {
        borderRight: "2px solid #00000011",
      },
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "2px solid #00000011",
  }));

  const subscriptionStatusFunc = async (data) => {
    setisLoading(true);
    let temp = {
      id: data._id,
      status: data.status === "Active" ? "Inactive" : "Active",
    };
    try {
      let res = await subscription_status_api(temp);
      console.log(res);
      if (res.data.status) {
        setisLoading(false);
        fetchAllSubscriptionList();
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        setisLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      notificationHandler({ type: "danger", msg: error.message });
    }
  };

  //  This is used to export the data in the excel file

  let settings = {
    fileName: "Transaction List", // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    // RTL: true, // Display the columns from right-to-left (the default value is false)
  };

  const exportTransactionFunc = (adiminTransaction) => {
    if (adiminTransaction.length < 1) {
      return toast.alert("No Data available foe export");
    }
    let data = [
      {
        sheet: "Users Data",
        columns: [
          {
            label: "Created Date",
            value: (row) =>
              row?.created_at ? row?.created_at?.slice(0, 10) : "",
          },
          {
            label: "Status",
            value: (row) => (row?.status ? row?.status : ""),
          },
          {
            label: "Event Price",
            value: (row) => (row?.eventId ? row?.eventId?.price : ""),
          },
          {
            label: "Event Date",
            value: (row) =>
              row?.eventId ? String(row?.eventId?.date).slice(0, 10) : "",
          },
          {
            label: "Event Name",
            value: (row) => (row?.eventId ? row?.eventId?.name : ""),
          },
          {
            label: "User Phone No.",
            value: (row) => (row?.userId ? row?.userId?.phone : ""),
          },
          {
            label: "User Name",
            value: (row) => (row?.userId ? row?.userId?.name : ""),
          },
          {
            label: "Transaction ID",
            value: (row) => (row?.transactionId ? row?.transactionId : ""),
          },
          {
            label: "Order ID",
            value: (row) => (row?.orderId ? row?.orderId : ""),
          },
          {
            label: "Payment ID",
            value: (row) => (row?.paymentId ? row?.paymentId : ""),
          },
        ],
        content: adiminTransaction,
      },
    ];
    let callback = function (sheet) {
      console.log("Download complete:", sheet);
    };
    try {
      xlsx(data, settings, callback);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="">
        <div className="beat_heading">
          <div className={s["user-list-heading"]}>
            <div className="user-list-title">
              <h3>Subsctription List</h3>
            </div>
            <div className={s["user-list-search"]}>
              <div className={s["search-box"]}>
                <span style={{ paddingRight: "0.5rem" }}>
                  <BiSearch size={23} />
                </span>
                <input
                  type="text"
                  spellCheck="false"
                  onChange={(e) => {
                    setpageCount(1);
                    setsearch(e.target.value);
                  }}
                  placeholder="Search by name"
                />
              </div>
              <div className={s["title"]}>
                <span
                  onClick={() => exportTransactionFunc(allSubscription)}
                  style={{ paddingRight: "2px" }}
                >
                  Export to Excel
                </span>
              </div>
              {/* <div className={s["filter-btn"]}>
                <span style={{ paddingRight: "2px" }}>
                  <BiFilter size={20} />
                </span>
                Filter
              </div> */}
            </div>
          </div>
          <div className={s["beat_left"]}>
            <div
              className={s["title"]}
              onClick={() =>
                navigate("/add-subscription", {
                  state: {
                    pagetype: "Add",
                  },
                })
              }
            >
              <IoMdAdd /> subscription
            </div>
          </div>
        </div>
        <div className="">
          <div className={s["date_input_box"]}>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setstartDate(e.target.value)}
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => setendDate(e.target.value)}
            />
            <select onChange={(e) => setstatusFilter(e.target.value)}>
              <option value="">Select Status filter</option>
              <option value="pending">pending</option>
              <option value="success">success</option>
              <option value="failed">failed</option>
            </select>
          </div>
          {/* <div className={s["mock_test_dropdown"]}></div>
                  <div className={s["mock_test_dropdown"]}></div> */}
        </div>
        <div className="beat_table">
          <Box
            sx={{
              minWidth: "700px",
              overflowX: "auto",
            }}
          >
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">Image</StyledTableCell>
                  <StyledTableCell align="center" style={{ minWidth: "300px" }}>
                    Name
                  </StyledTableCell>
                  <StyledTableCell align="center" style={{ minWidth: "300px" }}>
                    Hindi Name
                  </StyledTableCell>
                  <StyledTableCell align="center">Place</StyledTableCell>
                  <StyledTableCell align="center">Hindi Place</StyledTableCell>
                  <StyledTableCell align="center">
                    Primary God Name
                  </StyledTableCell>
                  <StyledTableCell align="center">Purpose</StyledTableCell>
                  <StyledTableCell align="center">
                    Subscription Plans
                  </StyledTableCell>
                  <StyledTableCell align="center" style={{ minWidth: "400px" }}>
                    Benefits
                  </StyledTableCell>
                  <StyledTableCell align="center" style={{ minWidth: "400px" }}>
                    Hindi Benefits
                  </StyledTableCell>
                  <StyledTableCell align="center" style={{ minWidth: "300px" }}>
                    FAQs
                  </StyledTableCell>
                  <StyledTableCell align="center" style={{ minWidth: "300px" }}>
                    Hindi FAQs
                  </StyledTableCell>
                  <StyledTableCell align="center">Status</StyledTableCell>
                  <StyledTableCell align="center">Action</StyledTableCell>
                </TableRow>
              </TableHead>
              {/* <div style={{ margin: "0.5rem 0" }}></div> */}
              <TableBody>
                {allSubscription?.map((row) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell>
                      {
                        <img
                          src={getBaseUrl2() + row?.thumbImage}
                          alt="error"
                        />
                      }
                    </StyledTableCell>
                    <StyledTableCell> {row?.name} </StyledTableCell>
                    <StyledTableCell> {row?.hindiName} </StyledTableCell>
                    <StyledTableCell> {row?.place}</StyledTableCell>
                    <StyledTableCell> {row?.HindiPlace}</StyledTableCell>
                    <StyledTableCell align="center">
                      {row?.primaryGodName}{" "}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row?.purpose}{" "}
                    </StyledTableCell>
                    <StyledTableCell>
                      {row?.plainItems?.map((data) => (
                        <div>
                          <p>
                            <b>Price:</b>
                            {data?.price}
                          </p>
                          <p>
                            <b>Duration:</b>
                            {data?.duration}
                          </p>
                          --------------------------
                        </div>
                      ))}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "20rem" }}>
                      {row?.benefits?.map((data) => (
                        <div>
                          <p>
                            <b>Heading:</b>
                            {data?.heading}
                          </p>
                          <p>
                            <b>Value:</b>
                            {data?.value}
                          </p>
                          --------------------------------------
                        </div>
                      ))}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "20rem" }}>
                      {row?.hindiBenefits?.map((data) => (
                        <div>
                          <p>
                            <b>Heading:</b>
                            {data?.heading}
                          </p>
                          <p>
                            <b>Value:</b>
                            {data?.value}
                          </p>
                          --------------------------------------
                        </div>
                      ))}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "20rem" }}>
                      {row?.faq?.map((data) => (
                        <div>
                          <p>
                            <b>Heading:</b>
                            {data?.heading}
                          </p>
                          <p>
                            <b>Value:</b>
                            {data?.value}
                          </p>
                          --------------------------------------
                        </div>
                      ))}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "20rem" }}>
                      {row?.hindiFaq?.map((data) => (
                        <div>
                          <p>
                            <b>Heading:</b>
                            {data?.heading}
                          </p>
                          <p>
                            <b>Value:</b>
                            {data?.value}
                          </p>
                          --------------------------------------
                        </div>
                      ))}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => subscriptionStatusFunc(row)}
                        className={`${
                          row.status === "Active"
                            ? s.active_admin
                            : s.inactive_admin
                        }`}
                      >
                        {row.status}
                      </div>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <CiEdit
                        onClick={() =>
                          navigate("/add-subscription", {
                            state: {
                              pagetype: "Edit",
                              data: row,
                            },
                          })
                        }
                        style={{
                          fontSize: "1rem",
                          color: "var(--clr-primary)",
                          marginRight: "0.5rem",
                          cursor: "pointer",
                        }}
                      />
                      <MdDelete
                        onClick={() => {
                          setdeletePopup(true);
                          setcurrentGroup(row);
                          setdeleteId(row._id);
                        }}
                        style={{
                          fontSize: "1rem",
                          color: "var(--clr-primary)",
                          cursor: "pointer",
                        }}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
          {allSubscription?.length <= 0 && <DataNotFound />}
          {allSubscription?.length > 0 && (
            <div className={s["pagination"]}>
              <Pagination
                count={pageLength}
                size="large"
                style={{ color: "#D21903" }}
                onChange={(e, value) => setpageCount(value)}
                page={pageCount}
              />
            </div>
          )}
        </div>
        <Dialog
          open={deletePopup}
          aria-labelledby="form-dialog-title"
          maxWidth="xs"
          fullWidth="true"
          onClose={() => setdeletePopup(false)}
        >
          <DialogTitle className={s.dialog_title}>
            <div>Do you want to delete {currentGroup.name}?</div>
          </DialogTitle>
          <DialogContent className={s.cardpopup_content}>
            <div style={{ display: "flex", gap: "1rem" }}>
              <div
                className={s.employee_gl_popup}
                onClick={() => setdeletePopup(false)}
              >
                Cancel
              </div>
              <div
                className={s.employee_gl_popup_del}
                onClick={() => deleteSubscriptionFunc()}
              >
                Delete
              </div>
            </div>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
        <Loder loading={isLoading} />
      </div>
    </>
  );
};

export default SubscriptonList;
